export const navigateToMappingConfig = (navigate) => {
  navigate(`../dashboard`);
};
